

<form class="example-form">
    <mat-form-field class="example-full-width">
      <mat-label>Input</mat-label>
      <input matInput placeholder="Sharepoint path/folder name" value="">
    </mat-form-field>
    <button mat-flat-button (click)="onSubmit()">Submit</button>
    <button mat-flat-button>Next</button>
</form>


